import { BoxV2 as Box, Flex, Grid } from 'portal-commons';
import { forwardRef, useMemo } from 'react';

import { CspCampaign, MnoEnum } from '@/apis/core';

type BoxProps = React.ComponentProps<typeof Box>;

interface MnoStatusSectionProps {
  campaign: CspCampaign;
  mnos: MnoEnum[];
  sx?: BoxProps['sx'];
}

const MnoStatusSection = forwardRef<HTMLDivElement, MnoStatusSectionProps>(
  ({ campaign, mnos, sx }, ref) => {
    const availableMnos = useMemo(
      () => mnos.filter((mno) => !!campaign.operationStatuses?.[mno.networkId]),
      [campaign, mnos]
    );

    return (
      <Grid
        data-testid="mnoStatusSection"
        ref={ref}
        sx={{
          position: 'absolute',
          top: '38px',
          right: 0,
          left: 0,
          gridTemplateColumns: 'repeat(3, 1fr)',
          rowGap: 'm',
          padding: '16px 24px 24px',
          ...sx,
        }}
      >
        {availableMnos.map((mno) => (
          <Flex
            key={mno.networkId}
            sx={{
              flexDirection: 'column',
              gap: 'xxs',
              width: 'fit-content',
              fontWeight: 400,
              fontSize: 'H200',
              lineHeight: 'normal',
            }}
          >
            <Box sx={{ color: 't.paleRed700', fontWeight: 600 }}>
              {mno.displayName}
            </Box>
            <Box sx={{ color: 't.black60' }}>
              MNO Status:{' '}
              <span style={{ fontWeight: 600 }}>
                {campaign.operationStatuses?.[mno.networkId] ?? 'N/A'}
              </span>
            </Box>
          </Flex>
        ))}
      </Grid>
    );
  }
);

export default MnoStatusSection;
